import EASubscriptionService from "../../../../services/EASubscriptionService/EASubscriptionService";
import { useQuery } from "react-query";

export function useUserActivityDetails(userPeriod: string) {
    const saasService = new EASubscriptionService({});
    const days = `D${userPeriod}`;
    const commonQueryOptions = {
        refetchOnWindowFocus: false,
        staleTime: 2 * 60 * 1000, // 2 minutos
        cacheTime: 5 * 60 * 1000, // 2 minutos
    };
    const teamsQuery = useQuery(['teamsActivity', days],
        () =>  saasService.GetTeamsUserActivityUserDetailWithPeriod(days),
        commonQueryOptions
    );
    const sharePointQuery = useQuery(['sharePointActivity', days], 
        () =>  saasService.GetSharePointActivityUserDetailWithPeriod(days),
        commonQueryOptions
    );
    const emailQuery = useQuery(['emailActivity', days], 
        () =>  saasService.GetEmailActivityUserDetailWithPeriod(days),
        commonQueryOptions
    );
    const oneDriveQuery = useQuery(['oneDriveActivity', days],
        () => saasService.GetOneDriveUsageAccountDetailWithPeriod(days),
        commonQueryOptions
        );

    const isInitialLoading =
        teamsQuery.isLoading ||
        sharePointQuery.isLoading ||
        emailQuery.isLoading ||
        oneDriveQuery.isLoading;
    const isRefetching =
        teamsQuery.isFetching ||
        sharePointQuery.isFetching ||
        emailQuery.isFetching ||
        oneDriveQuery.isFetching;
      
    const loading = isInitialLoading || isRefetching; 

    return {
        teamsDetail: teamsQuery.data,
        sharePointDetail: sharePointQuery.data,
        emailDetail: emailQuery.data,
        oneDriveDetail: oneDriveQuery.data,
        loading,
        error:
            teamsQuery.error ||
            sharePointQuery.error ||
            emailQuery.error ||
            oneDriveQuery.error,
            refetchAll: () => {
            teamsQuery.refetch();
            sharePointQuery.refetch();
            emailQuery.refetch();
            oneDriveQuery.refetch();
            },
        };
    };
